<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("add") }} {{ $tc("cinema", 1) }} {{ $t("loyaltysettings") }}
      </div>
      <router-link class="btn-blue" to="cinema-loyalty-settings"
        >{{ $tc("cinema", 1) }} {{ $t("loyaltysettings") }}
        {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="selectedcinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in cinemaList"
                  :key="cinemaIndex"
                  @click.prevent.stop="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedcinema.length == 0"
              class="error_message"
            >
              <span>{{ $t("pleaseSelectCinema") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="globalloyaltyname.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("global") }}
                {{ $t("loyaltysettings") }}</label
              >
              <b-dropdown
                :text="globalloyaltyname"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(
                    globallist, globallistIndex
                  ) in globalloyaltysettingsList"
                  :key="globallistIndex"
                  @click.prevent.stop="
                    onSelectGlobalLoyaltySettings(globallist)
                  "
                  >{{ globallist.ls_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p
              v-if="submitted && globalloyaltyname.length == 0"
              class="error_message"
            >
              <span
                >{{ $t("please") }} {{ $t("select") }} Global
                {{ $t("loyaltysettings") }}</span
              >
            </p>
          </div>

          <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("canavailonline") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_online"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatboxoffice") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_bo"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatconcession") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_fnb"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </div>
              </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4 mt-2" v-if="false">
            <div class="row mx-0">
              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("canavailonline") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_online"
                    unchecked-value="N"
                    value="Y"
                    switch
                    class="j-checkbox"
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatboxoffice") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_bo"
                    unchecked-value="N"
                    value="Y"
                    switch
                    class="j-checkbox"
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatconcession") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_fnb"
                    unchecked-value="N"
                    value="Y"
                    switch
                    class="j-checkbox"
                  ></b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              {{ $t("minimumpointsforredemption") }} :
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.minimum_points_redemption"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="minimumreedempoints"
                  id="minimumreedempoints"
                />
              </div>
              <p
                v-if="submitted && errors.has('minimumreedempoints')"
                class="error_message"
              >
                <span>{{ errors.first("minimumreedempoints") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              {{ $t("maximumpointstoberedeemedpertransaction") }} :
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.maximum_points_redemption"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="maximumreedempoints"
                  id="maximumreedempoints"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('maximumreedempoints')"
              class="error_message"
            >
              <span>{{ errors.first("maximumreedempoints") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>3.&nbsp;</strong>
              {{ $t("minimumpointsearnings") }} :
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.minimum_points_earning"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="minimumpointearning"
                  id="minimumpointearning"
                />
              </div>
              <p
                v-if="submitted && errors.has('minimumpointearning')"
                class="error_message"
              >
                <span>{{ errors.first("minimumpointearning") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>4.&nbsp;</strong>
              {{ $t("maximumpointsearnings") }} :
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.maximum_points_earning"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="maximumpointearning"
                  id="maximumpointearning"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('maximumpointearning')"
              class="error_message"
            >
              <span>{{ errors.first("maximumpointearning") }}</span>
            </p>
          </div> -->

           <div class="col-lg-6 col-xl-3 mb-2">
            <div class="row mx-0 align-items-center">
              <!-- <strong>3.&nbsp;</strong> -->
              {{ $t("minimumpointsearnings") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.minimum_points_earning"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="minimumpointearning"
                  id="minimumpointearning"
                />
              </div>
              <p
                v-if="submitted && errors.has('minimumpointearning')"
                class="error_message"
              >
                <span>{{ errors.first("minimumpointearning") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-2">
            <div class="row mx-0 align-items-center">
              <!-- <strong>4.&nbsp;</strong> -->
              {{ $t("maximumpointsearnings") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.maximum_points_earning"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="maximumpointearning"
                  id="maximumpointearning"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('maximumpointearning')"
              class="error_message"
            >
              <span>{{ errors.first("maximumpointearning") }}</span>
            </p>
          </div>

           <div class="col-lg-6 col-xl-3 mb-2">
            <div class="row mx-0 align-items-center">
              <!-- <strong>1.&nbsp;</strong> -->
              {{ $t("minimumpointsforredemption") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.minimum_points_redemption"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="minimumreedempoints"
                  id="minimumreedempoints"
                />
              </div>
              <p
                v-if="submitted && errors.has('minimumreedempoints')"
                class="error_message"
              >
                <span>{{ errors.first("minimumreedempoints") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-8 mb-4">
            <div class="row mx-0 align-items-center">
              <!-- <strong>2.&nbsp;</strong> -->
              {{ $t("maximumpointstoberedeemedpertransaction") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.maximum_points_redemption"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="maximumreedempoints"
                  id="maximumreedempoints"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('maximumreedempoints')"
              class="error_message"
            >
              <span>{{ errors.first("maximumreedempoints") }}</span>
            </p>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4 mt-2" v-if="false">
            <div class="row mx-0">
              <strong>5.&nbsp;</strong>
              {{ $t("requirementtoenroll") }}
              <b-form-checkbox
                v-model="cinema_loyalty_settings.email_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>{{ $t("email") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.mobile_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>{{ $t("mobiles") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.age_proof_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>{{ $t("age") }} {{ $t("proof") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.id_proof_is_required"
                class="j-checkbox mx-3"
              >
                <div>Id {{ $t("proof") }}</div>
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 mb-4">
            <div class="d-flex">
              <!-- <strong>6.&nbsp;</strong> -->
              <div class="input-material-textarea">
                <textarea
                  v-model="cinema_loyalty_settings.eligibility_to_enroll"
                  rows="2"
                  v-validate="'required'"
                  type="text"
                  name="eligibilitytoenroll"
                  id="eligibilitytoenroll"
                  class="rounded-10"
                ></textarea>
                <label>{{ $t("eligibilitytoenroll") }}</label>
              </div>
            </div>
            <p
              v-if="submitted && errors.has('eligibilitytoenroll')"
              class="error_message"
            >
              <span>{{ errors.first("eligibilitytoenroll") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <!-- <strong>7.&nbsp;</strong> -->
                {{ $t("earnpointsondicount") }}
              </div>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.earn_points_on_discount"
                unchecked-value="N"
                value="Y"
                switch
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <!-- <strong>8.&nbsp;</strong> -->
                {{ $t("burnpointsondicount") }}
              </div>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.burn_points_on_discount"
                unchecked-value="N"
                value="Y"
                switch
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="h6 w-100 px-3">{{ $t("earnpoints") }}</div>
          <div class="col-lg-6 col-xl-6 mb-3">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("boxoffice") }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.earn_ratio_bo"
                  v-validate="'required|numeric'"
                  type="number"
                  name="earnboxofficeratio"
                  id="earnboxofficeratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('earnboxofficeratio')"
                class="error_message"
              >
                <span>{{ errors.first("earnboxofficeratio") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $tc("fb", 1) }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.earn_ratio_fnb"
                  v-validate="'required|numeric'"
                  type="number"
                  name="earnfnbratio"
                  id="earnfnbratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('earnfnbratio')"
                class="error_message"
              >
                <span>{{ errors.first("earnfnbratio") }}</span>
              </p>
            </div>
          </div>

          <div class="h6 w-100 px-3">{{ $t("burnpoints") }}</div>

          <div class="col-lg-6 col-xl-6 mb-3">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("boxoffice") }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.burn_ratio_bo"
                  v-validate="'required|numeric'"
                  type="number"
                  name="burnboxofficeratio"
                  id="burnboxofficeratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('burnboxofficeratio')"
                class="error_message"
              >
                <span>{{ errors.first("burnboxofficeratio") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $tc("fb", 1) }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="cinema_loyalty_settings.burn_ratio_fnb"
                  v-validate="'required|numeric'"
                  type="number"
                  name="burnfnbratio"
                  id="burnfnbratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('burnfnbratio')"
                class="error_message"
              >
                <span>{{ errors.first("burnfnbratio") }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-4">
        <div class="row">
          <div class="col-md-3 col-xl-2">
            <label>{{ $t("active") }}</label>
          </div>
          <div class="col-md-9 col-xl-10">
            <div>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.cls_is_active"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="cinema-loyalty-settings"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      cinemaListCopy: [],
      searchCinema: "",
      btenable: false,
      submitted: false,
      isRoleID: true,
      cinemaList: [],
      globalloyaltysettingsList: [],
      globalloyaltyname: "",
      selectedcinema: "",
      cinema_loyalty_settings: {
        cls_name: null,
        cinema_id: null,
        ls_id: null,
        redemption_online: "Y",
        redemption_bo: "Y",
        redemption_fnb: "Y",
        minimum_points_redemption: "",
        maximum_points_redemption: "",
        minimum_points_earning: "",
        maximum_points_earning: "",
        email_is_required: "Y",
        mobile_is_required: "N",
        age_proof_is_required: "N",
        id_proof_is_required: "N",
        eligibility_to_enroll: "",
        earn_ratio_bo: "",
        earn_ratio_fnb: "",
        burn_ratio_bo: "",
        burn_ratio_fnb: "",
        earn_points_on_discount: "Y",
        burn_points_on_discount: "N",
        cls_is_active: "Y",
      },
    };
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
      this.getValidCinemaList(obj);
    } else {
      this.getValidCinemaList(obj);
    }
    // this.getValidCinemaList();
    this.getGlobalLoyaltySettingsList();
  },
  methods: {
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    getValidCinemaList(cine_id) {
      CinemasService.GetValidCinemasLoyalty({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;

            if (cine_id === undefined) {
            } else {
              this.cinemaList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.cinema_loyalty_settings.cinema_id = x.cine_id;
                  this.selectedcinema = x.cine_name;
                }
              });
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    resetHandler: function () {
      this.globalloyaltyname = "";
      this.selectedcinema = "";
      this.submitted = false;
      this.cinema_loyalty_settings = {
        cls_name: null,
        cinema_id: null,
        ls_id: null,
        redemption_online: "Y",
        redemption_bo: "Y",
        redemption_fnb: "Y",
        minimum_points_redemption: "",
        maximum_points_redemption: "",
        minimum_points_earning: "",
        maximum_points_earning: "",
        email_is_required: "Y",
        mobile_is_required: "N",
        age_proof_is_required: "N",
        id_proof_is_required: "N",
        eligibility_to_enroll: "",
        earn_ratio_bo: "",
        earn_ratio_fnb: "",
        burn_ratio_bo: "",
        burn_ratio_fnb: "",
        earn_points_on_discount: "Y",
        burn_points_on_discount: "N",
        cls_is_active: "Y",
      };
    },
    getGlobalLoyaltySettingsList: function () {
      MarketingService.GetActiveGlobalLoyaltySettings({
        activekey: "ls_is_active",
      })

        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.globalloyaltysettingsList = data.Records;
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (params) {
      this.cinema_loyalty_settings.cinema_id = params.cine_id;
      this.selectedcinema = params.cine_name;
      this.searchCinema = "";
      this.onSearchCinema();
    },
    onSelectGlobalLoyaltySettings(params) {
      this.cinema_loyalty_settings.ls_id = params.ls_id;
      this.globalloyaltyname = params.ls_name;
    },
    addLoyaltySettings: function () {
      this.loyalty_levels.push({
        ll_name: "",
      });
    },
    removeLoyaltySettings: function (index) {
      this.loyalty_levels.splice(index, 1);
    },

    OnFinalSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (
          this.cinema_loyalty_settings.cinema_id == null ||
          this.cinema_loyalty_settings.cinema_id.length == 0
        ) {
          return;
        } else if (this.globalloyaltyname.length == 0) {
          return;
        } else if (this.selectedcinema.length == 0) {
          return;
        }
        if (valid) {
          this.btenable = true;

          let payload = {
            cls: this.cinema_loyalty_settings,
          };

          MarketingService.AddCinemaLoyaltySettings(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;
              if (data.status) {
                this.submitted = false;
                this.$router.push({
                  path: "/marketing/cinema-loyalty-settings",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltySettingsComponents/addcinemaloyaltysettings.vue